import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, Tooltip, Legend, Title, LinearScale, CategoryScale } from 'chart.js';

ChartJS.register(BarElement, Tooltip, Legend, Title, LinearScale, CategoryScale);

// Get the current month index (0 = January, 11 = December)
const currentMonthIndex = new Date().getMonth();

// Data for the chart
const data = {
    labels: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ],
    datasets: [
        {
            label: 'Monthly Listeners',
            data: [50, 70, 40, 55, 45, 75, 40, 50, 35, 60, 45, 120], // Example data
            backgroundColor: Array(12).fill('rgba(255, 99, 132, 0.5)').map((color, index) =>
                index === currentMonthIndex ? 'rgba(255, 0, 0, 1)' : color
            ), 
            borderRadius: 5,
            borderSkipped: false,
        }
    ]
};

// Chart options for perfect fitting
const options = {
    responsive: true,
    maintainAspectRatio: false,  // Disables fixed aspect ratio to allow full control
    plugins: {
        legend: {
            display: false
        },
        tooltip: {
            enabled: true
        },
        title: {
            display: true,
        }
    },
    scales: {
        y: {
            beginAtZero: true,
            grid: {
                display: false
            },
            ticks: {
                stepSize: 50
            }
        },
        x: {
            grid: {
                display: false
            }
        }
    }
};

const MonthlyListenersChart = () => {
    return (
        <div style={{
            width: "100%",
            height: "100%"
        }}> 
            {/* Set your desired dimensions here */}
            <Bar data={data} options={options} />
        </div>
    );
};

export default MonthlyListenersChart;
